export default "/Frontend/dist/logo-white.89f415b03fd0e93079a2aa5546d298e8.svg";